// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import XngZone from "@keller/App/Components/Common/XngZone";
import { DivWrapper } from "@keller/XDL/constants";
import { xScreen } from "@keller/XDL/Utilities";
import React, { FC } from "react";
import { css } from "styled-components";

type Props = WidgetProps;

interface SignInPageLayoutStyles {
    container?: InjectableCss;
}

const signInPageLayout: SignInPageLayoutStyles = {
    container: {
        css: css`
            display: grid;
            grid-template-columns: 1fr 1fr;
            margin-left: 55px;
            gap: 20px;
            justify-content: space-between;
            & > ${DivWrapper}:last-child {
                max-width: 528px;
                grid-area: 2 / 1 / 3 / 2;
            }

            ${xScreen("lte", "sm")} {
                margin-left: 0;
            }
            ${xScreen("lte", 767)} {
                grid-template-columns: 1fr;
            }
        `,
    },
};

const styles = signInPageLayout;
const SignInPageLayout: FC<Props> = ({ id }) => {
    return (
        <StyledWrapper {...styles.container} data-test-selector="SignInPageLayout">
            <XngZone contentId={id} zoneName="Content00" hint="SignInExistingAccount" />
            <XngZone contentId={id} zoneName="Content01" hint="CreateAccount" />
            <XngZone contentId={id} zoneName="Extra hints" />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: SignInPageLayout,
    definition: {
        group: "Layout" as any,
        displayName: "SignIn page layout",
        allowedContexts: ["SignInPage"],
    },
};

export default widgetModule;
